import { Button, Inset, Pane } from '@criteria-labs/react'
import { ProjectFile, ProjectManager, useProjectSelection } from '../project'
import openAPITemplate from '../templates/openapi'
import petstore3_0Template from '../templates/petstore3_0'
import petstore3_1Template from '../templates/petstore3_1'
import readmeTemplate from '../templates/readme'
import schemaTemplate from '../templates/schema'
import spectralTemplate from '../templates/spectral'

export function NoDocumentView() {
  const { selection, select } = useProjectSelection()
  const createFileAtSelection = (name: string, text: string) => {
    const parentFolder = ProjectManager.shared().getNearestFolder(selection)
    ProjectManager.shared().createFileSync(parentFolder, name, text, (createdFile: ProjectFile) => {
      select(createdFile.path, true)
    })
  }
  return (
    <Pane background="secondary" className="flex items-center justify-center">
      <Inset>
        <p className="mb-12 text-lg/6 font-normal">Choose a template to get started:</p>
        <div className="grid w-full grid-cols-3 gap-6">
          <h3 className="col-span-full text-sm/6">API</h3>
          <Button
            outline
            className="h-16"
            onClick={() => createFileAtSelection(openAPITemplate.name, openAPITemplate.text)}
          >
            OpenAPI Document
          </Button>
          <Button
            outline
            className="h-16"
            onClick={() => createFileAtSelection(petstore3_0Template.name, petstore3_0Template.text)}
          >
            Swagger Petstore (3.0)
          </Button>
          <Button
            outline
            className="h-16"
            onClick={() => createFileAtSelection(petstore3_1Template.name, petstore3_1Template.text)}
          >
            Swagger Petstore (3.1)
          </Button>
          <h3 className="col-span-full text-sm/6">Schema</h3>
          <Button
            outline
            className="h-16"
            onClick={() => createFileAtSelection(schemaTemplate.name, schemaTemplate.text)}
          >
            JSON Schema Document
          </Button>
          <h3 className="col-span-full text-sm/6">Style Guide</h3>
          <Button
            outline
            className="h-16"
            onClick={() => createFileAtSelection(spectralTemplate.name, spectralTemplate.text)}
          >
            Spectral Ruleset
          </Button>
          <h3 className="col-span-full text-sm/6">Markdown</h3>
          <Button
            outline
            className="h-16"
            onClick={() => createFileAtSelection(readmeTemplate.name, readmeTemplate.text)}
          >
            Readme
          </Button>
        </div>
      </Inset>
    </Pane>
  )
}
